import { render, staticRenderFns } from "./ToAcknowledge.vue?vue&type=template&id=34ddad5b&"
import script from "./ToAcknowledge.vue?vue&type=script&lang=js&"
export * from "./ToAcknowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports